import { first } from "lodash";
import module from "../helper/inject";

/** @type jQuery **/
const $ = module.$();

let originalId = 0;
$(document).ready(() => {
  setTimeout(() => {
    addListeners();

    // trigger change event for all programme selects on initial load
    $('.programmeSelect select').each(function() {
      $(this).trigger('change');
    });
  }, 1500);

  // if programme which id is in get req is not available
  let searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has('programmeId')) {
    const programmeId = searchParams.get('programmeId');
    
    if ($('.bundle select option[value=' + programmeId + ']')[0]) {
      //
    } else {
      $('.basket_empty_msg').text('You are already registered for the selected programme. Please continue with your learning.').show();
      $('.programmeSelect').css('text-align', 'center');
      $('.winsButton--next').addClass('disabled');
      $('.bundle').hide();
    }

  }

  function addListeners() {
    const totals = $("[programme-totals]");
    const pricePoints = $("input[type=checkbox], input[type=text], .programmeDropdownItem, .programmeSelect input, .programmeSelect select");
    const totalsData = {};

    let searchParams = new URLSearchParams(window.location.search)
    const isCorporate = searchParams.get('purchaseType') == 'corporate';

    $('.programmeSelect select').each(function() {
      $(this).on('change', function(el) {
        const voucherCanPurcase = $(el.target).find(':selected').data('voucher-can-purchase');
        const recertCanPurcase = $(el.target).find(':selected').data('recert-can-purchase');
        const lmsCanPurchase = $(el.target).find(':selected').data('lms-can-purchase');
        const textbookCanPurchase = $(el.target).find(':selected').data('textbook-can-purchase');
        const isLatestVersion = $(el.target).find(':selected').data('is-latest-version');
        let totalAddons = 0;

        const selectedName = $($(el.target).find(':selected')).text();
        const isCprssm = selectedName.toUpperCase().includes('CPRSSM');

        const latestId = $(el.target).children("option:selected").data('latest-version-id');
        const name = $($(el.target).children("option[value='" + latestId + "']")[0]).text().trim();

        const bundle = $($(this).closest('.bundle')[0]);
        const caution = $(bundle.find('.caution_same_version')[0]);

        if (!isLatestVersion) {
          $(caution.find('.caution_programme_name')[0]).text(name ? '\"' + name + '\"' : 'programme');
          caution.show();
        } else {
          caution.hide();
        }

        // change price for cprssm addon items
        if (isCprssm) {
          $('.addons .addon_item').each(function(addonEl, ell) {
            const addon = $(this);
            const newPrice = addon.data('cprssm-price');
            addon.find('.addon_price').text('(' + newPrice + 'EUR)');
          });
        } else {
          $('.addons .addon_item').each(function(addonEl, ell) {
            const addon = $(this);
            const newPrice = addon.data('standard-price');
            addon.find('.addon_price').text('(' + newPrice + 'EUR)');
          });
        }

        // $(el.target).closest('.bundle').find('input').prop('checked', false);

        if (!isCorporate) {
          // can purchase recert voucher only if has 'No Show' or if failed exam
          if (recertCanPurcase != 1) {
            $(el.target).closest('.bundle').find('.addon_item').last().find('input').prop('checked', false);
            $(el.target).closest('.bundle').find('.addon_item').last().css('display', 'none');
          } else {
            $(el.target).closest('.bundle').find('.addon_item').last().css('display', 'block');
            totalAddons++;
          }

          // can purchase voucher if hasnt been purchased before for this programme
          if (voucherCanPurcase != 1) {
            $(el.target).closest('.bundle').find('.addon_item.addon_3').last().find('input').prop('checked', false);
            $(el.target).closest('.bundle').find('.addon_item.addon_3').last().css('display', 'none');
          } else {
            $(el.target).closest('.bundle').find('.addon_item.addon_3').last().css('display', 'block');
            totalAddons++;
          }

          // disable or enable lms (if it was purchased already)
          if (lmsCanPurchase != 1) {
            $(el.target).closest('.bundle').find('.addon_item.addon_1').first().find('input').prop('checked', false);
            $(el.target).closest('.bundle').find('.addon_item.addon_1').first().css('display', 'none');
          } else {
            $(el.target).closest('.bundle').find('.addon_item.addon_1').first().css('display', 'block');
            totalAddons++;
          }

          // disable or enable lms (if it was purchased already)
          if (textbookCanPurchase != 1) {
            $(el.target).closest('.bundle').find('.addon_item.addon_2').first().find('input').prop('checked', false);
            $(el.target).closest('.bundle').find('.addon_item.addon_2').first().css('display', 'none');
          } else {
            $(el.target).closest('.bundle').find('.addon_item.addon_2').first().css('display', 'block');
            totalAddons++;
          }

          // if at 1 or 0 addons, hide 'select all' checkbox
          if (totalAddons <= 1) {
            $($('input.selectAll').parent()[0]).hide();
          } else {
            $($('input.selectAll').parent()[0]).show();
          }
        }
        
      });

      $('.response_yes').unbind('click').on('click', function(e) {
        e.preventDefault();
        const bundle = $($(this).closest('.bundle')[0]);
        const select = $(bundle.find('select')[0]);
        
        const lastId = select.children("option:selected").data('latest-version-id');

        const newOption = $(select.children("option[value='" + lastId + "']")[0]);
        
        newOption.prop('selected', true);
        select.trigger('change');
        
        
      })
    });


    $('input.selectAll').on("change", onSelectAll);
    $('input:not(.selectAll)').on('change', function() {
      $(this).parent('').find('input.selectAll').prop('checked', false);
    });

    $(".inputPlus, .inputMinus").on("click", function () {
      setFullPrice();
    });

    $('.bundle .remove').unbind('click').on('click', function() {
      if ($('.bundle').length > 1) {
        $(this).parent('.bundle').remove();
        setFullPrice();
      } else if ($('.bundle').length == 1) {
          $('.basket_empty_msg').show();
          $('.programmeSelect').css('textAlign', 'center');
          $('.programmes .winsButton').addClass('disabled');
          $('.bundle').hide();
      }
    });

    $("#token").on("change", function () {
      setFullPrice();
    });

    pricePoints.each(function () {
      const ref = $(this);
      const name = ref.attr("name");
      const checkboxOrRadio = ref.attr("type") === "checkbox" || ref.attr("type") === "radio";

      ref.on("change", () => {
        setFullPrice();
      });
    });

    $(".customInput").click(function () {
      // console.log($(this));
    });

  }

  // recalculate total price and set it
  function setFullPrice() {
    var promo = $("#token").val().length > 0 ? $("#token").val() : "none";

    let data = {};

    $.each($("#purchase-form").serializeArray(), function (_, field) {
      const split = field.name.split("_");
      if (split.length == 2) {
        // if course not yet in data obj, add it (in case user picks addon items before selecting main course - so it doesnt throw an error)
        if (!("course_" + split[1] in data)) {
          data["course_" + split[1]] = {
            courseId: null,
            addons: [],
          };
        }
        // add course data and addons to data obj
        if (split[0] == "course") {
          data[field.name] = {
            courseId: field.value,
            addons: [],
          };
        } else {
          if (field.value != 0 && !isNaN(split[0])) {
            data["course_" + split[1]].addons.push(split[0]);
          }
        }
      }
    });

    jQuery
      .ajax({
        method: "post",
        data: 'programmes=' + JSON.stringify(data),
        url: "/promo/" + promo,
      })
      .done(function (res) {
        var price = res;
        jQuery("#totals").val(price);
      });
  }

  // when + is clicked 
  function onAddBundleClicked(e) {
    e.preventDefault();

    if ($('.bundle').length == 1 && $('.bundle').first().css('display') == 'none') {
      $('.basket_empty_msg').hide();
      $('.programmeSelect').css('textAlign', 'left');
      $('.programmes .winsButton').removeClass('disabled');
      $('.bundle').show();
    } else {

      const lastBundle = $('.bundle').last();
      let cloned = lastBundle.clone();
      const lastId = parseInt(cloned.find('select').attr('name').split('_')[1]);

      cloned.find('input').each(function () {
        const nameSplit = $(this).attr('name').split('_');
        $(this).attr('name', nameSplit[0] + '_' + (lastId + 1));
      })

      cloned.find('select').attr('name', 'course_' + (lastId + 1));


      cloned.insertAfter(lastBundle);
      addListeners();
    }

    setFullPrice();
  }

  $('#addCourse').on('click', onAddBundleClicked);


  // add items from 'cart' (sessionStorage)
  function loadCartItems() {
    const items = JSON.parse(sessionStorage.getItem('cartItems'));
    let programmeAvailable = false;

    if (items) {
      items.forEach(item => {
        const lastBundle = $('.bundle').last();
        let cloned = lastBundle.clone();
        const lastId = parseInt(cloned.find('select').attr('name').split('_')[1]);
        console.log(item.programmeId);

        // if programme is available to purchase
        if (cloned.find('select option[value=' + item.programmeId + ']')[0]) {
          console.log('available');
          programmeAvailable = true;
          cloned.find('input').each(function () {
            const nameSplit = $(this).attr('name').split('_');
            $(this).attr('name', nameSplit[0] + '_' + (lastId + 1));
            
            // check addon items 
            item.addons.forEach(addon => {
              if (nameSplit[0] == addon) {
                $(this).prop('checked', true);
              }
            })
    
    
          })
          cloned.find('select').attr('name', 'course_' + (lastId + 1));
          cloned.find('select').val(item.programmeId);
    
          cloned.insertAfter(lastBundle);          
        }

      });
    }

    if (programmeAvailable) {
      if (items) {
        $('.bundle').first().remove();
        setFullPrice();
      }
  
      addListeners();
    }

    sessionStorage.removeItem('cartItems');
  }
  loadCartItems();

  // select all checked
  function onSelectAll() {
    if ($(this).prop('checked')) {
      $(this).parent().parent().find('input[type=checkbox]:visible').prop('checked', true);
    }
  }
 
});
